






















import settings from '@/settings.coffee'
import gql from '@/gqlService.coffee'
import q from '@/gql/queries.coffee'
import Message from '@/components/Message'
import ImportReport from '@/components/ImportReport'

export default {
    "name": "ImportReportList"
    "components": {ImportReport}
    "props": {}
    "computed":{}
    "data":()->
        {
            "loading": true,
            "reports": []
        }
    "methods":
        "loadMore": ()->
            self = this
            console.log("loadMore")
            q.run("get_importreport_set", [self.reports.length]).then (data)->
                self.reports = self.reports.concat(data.body.data.importreport_set)
    "mounted": ()->
        self = @
        q.run("get_importreport_set", []).then (data)->
            self.loading = false
            self.reports = data.body.data.importreport_set
}
